module.exports = __webpack_public_path__ + "img/pt33_samurai01skin_shop.7749d595.png";